import {
    createSIWEConfig,
    formatMessage,
  } from '@web3modal/siwe'

const BASE_URL = process.env.REACT_APP_ENVIRONMENT === 'staging' ? 'https://backend.tippingpoint.app' : 'http://localhost:3000';

// call the server to get a nonce
 const getNonce = async () => {
    const res = await fetch(BASE_URL + '/nonce', {
        method: "GET",
        credentials: 'include',
      });
    if (!res.ok) {
        throw new Error('Network response was not ok');
    }
    const nonce = await res.text();
    console.log('Nonce:', nonce);
    return nonce;
}
  
// call the server to verify the message
 const verifyMessage = async ({ message, signature }) => {
    try {
        const response = await fetch(BASE_URL + '/verify', {
            method: "POST",
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ message, signature }),
            credentials: 'include'
        });

        if (!response.ok) {
            return false;
        }
        const result = await response.json();
        console.log('Result', result);
        return result === true;
      } catch (error) {
        return false;
      }
}

// call the server to get the session
 const getSession = async () => {
  console.log('Getting session');
   const res = await fetch(BASE_URL + '/session', {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: 'include',
  });
  console.log('Session response:', res);
  if (!res.ok) {
      throw new Error('Network response was not ok');
  }
  console.log('Session response 2:', JSON.stringify(res));
  let data = null;
  try {
    data = await res.json();

  } catch (error) {
    console.log('Error:', error);
  }
  console.log('Session:', data);
  return data == "{}" ?  null : data;
}

// call the server to sign out
const signOut =  async () => {
  const res = await fetch(BASE_URL + '/signout', {
   method: "GET",
   credentials: 'include',
 });
  if (!res.ok) {
      throw new Error('Network response was not ok');
  }
 
  const data = await res.json();
  return data == "{}";
} 

export const createSIWE = (chains) => {
    return createSIWEConfig({
      signOutOnAccountChange: true,
      signOutOnNetworkChange: true,
        getMessageParams: async () => ({
              domain: window.location.host,
              uri: window.location.origin, 
              chains,
              statement: 'Please sign with your account',
            }),
        createMessage: ({ address, ...args }) => {
          return formatMessage(args, address)
        },
        getNonce,
        getSession,
        verifyMessage,
        signOut,
    })
}